module.exports = {
    // Direccion IP Backend
    servidor: '',

    // Puerto Backend
    puerto: '8080'
};
